import { STATUS } from '../constants/status.constant';

export const cardState = (files) => {
	if (files.length === 0) {
		return STATUS.empty;
	}

	const someActive = files.some((objeto) => objeto.active === true);

	if (someActive) {
		return STATUS.active;
	}
	return STATUS.inactive;
};
